export default "__VITE_ASSET__DQT2iBlk__"